export const homeObjOne = {
  id: 'about',
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: '',
  headline: 'Moderne IT-Dienstleistungen für Ihr Unternehmen',
  description:
    'Wir helfen kleinen Unternehmen, Prozesse zu digitalisieren, zu automatisieren und sicher zu betreiben – effizient, verlässlich und individuell.',
  buttonLabel: 'Mehr erfahren',
  imgStart: false,
  img: require('../../images/iStock-1202843504.jpg'),
  alt: 'Digitalisierung',
  dark: true,
  primary: true,
  darkText: false,
  linkto: 'services'
};

export const homeObjTwo = {
  id: 'discover',
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: 'Entwicklung & Automatisierung',
  headline: 'Lösungen mit Microsoft 365 & Azure',
  description:
    'Mit über 10 Jahren Erfahrung entwickeln wir smarte Integrationen, Schnittstellen und automatisierte Abläufe – perfekt abgestimmt auf Ihre Geschäftsprozesse.',
  buttonLabel: 'Services Ansehen',
  imgStart: true,
  img: require('../../images/SoftSol_Logo_2025.png'),
  alt: 'Software Solution Logo',
  dark: false,
  primary: false,
  darkText: true,
  linkto: 'services'
};

export const homeObjThree = {
  id: 'services',
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: 'IT-Beratung & Infrastruktur',
  headline: 'Sicher in die Cloud – mit uns an Ihrer Seite',
  description:
    'Sie planen den Umstieg auf eine moderne Cloud-Infrastruktur? Wir begleiten Sie von der Planung bis zur Umsetzung – datenschutzkonform, sicher & verständlich.',
  buttonLabel: 'Beratung anfordern',
  imgStart: false,
  img: require('../../images/iStock-1530256492.jpg'),
  alt: 'Cloud Migration',
  dark: true,
  primary: true,
  darkText: false,
  linkto: 'contactme'
};
